import { paginateByPage, setStore, byUser } from 'src/feathers/hooks';

export default (app) => {
  const service = app.service('api/jobs');
  service.name = 'jobs';

  service.hooks({
    before: {
      all: [byUser],
      find: [paginateByPage],
      get: [],
      create: [],
      update: [],
      patch: [],
      remove: []
    },

    after: {
      all: [setStore],
      find: [],
      get: [],
      create: [],
      update: [],
      patch: [],
      remove: []
    },

    error: {
      all: [],
      find: [],
      get: [],
      create: [],
      update: [],
      patch: [],
      remove: []
    }
  });
};
